<template>
  <div>
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkbox-change="checkboxChange"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <div style="display: flex;justify-content: end;">
      <span slot="footer" class="mt-2">
        <el-badge hidden class="item">
          <el-button size="small" @click="close" class="mr-4">
            {{ $l('INDEX.btn_cancel') || '取消' }}</el-button
          >
        </el-badge>
        <el-badge :value="checkedRowCount" :max="99" class="item">
          <el-button :disabled="checkedRowCount < 1" size="small" type="primary" @click="save">{{
            $l('INDEX.btn_confirm') || '确定'
          }}</el-button>
        </el-badge>
      </span>
    </div>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'

export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader },
  props: {
    amzFlipOrderCode: { type: String, default: '' },
  },
  data() {
    return {
      usePage: true,
      updateDesignVisible: false,
      checkedRows: [],
      len: 0,
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzFlipOrderSpuListApi({
          ...form,
          ...this.page,
          amzFlipOrderCode: this.amzFlipOrderCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.len = Math.max(this.len, this.tableData.length)
        })
        .catch(() => {
          this.loading = false
        })
    },
    checkboxChange(data) {
      this.checkedRows = data
      this.$emit('checkboxChange', this.checkedRowCount)
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    getCheckedRow() {
      return this.checkedRows
    },
    getSkuSalesChannel() {
      return this.skuSalesChannel
    },
    getSkuSalesChannelText() {
      return this.skuSalesChannelText
    },
    close() {
      this.$emit('close')
    },
    save() {
      if (this.checkedRowCount == this.len) {
        this.$alert(
          '至少保留一个SPU',
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
            type: 'error',
            callback: () => {},
          }
        )
        return
      }
      this.$emit('save')
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
